import React from 'react';

const FeaturedBlogItem = ({ title, author, date, description, slug, category, image }) => {
  return (
    <>
      <div class="relative">
        <div class="absolute inset-0 h-1/2 bg-fadedBlue"></div>
        <div class="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="max-w-lg mx-auto rounded-lg overflow-hidden lg:max-w-none lg:flex">
            <div class="bg-white px-6 py-8 lg:p-12">
              <h3 class="text-2xl leading-8 font-extrabold text-gray-900 sm:text-3xl sm:leading-9">
                {title}
              </h3>
              <p class="mt-6 text-base leading-6 text-gray-500">{description}</p>
              <div class="">
                <ul class="mt-6 mb-8 lg:flex">
                  <li class="flex items-start text-yellow lg:col-span-1 lg:pr-4">{category}</li>
                </ul>

                <div class="mt-4 lg:flex ">
                  <div class="pr-4 font-medium text-blue ">{date}</div>
                  <a class="font-light pl-4 underline hover:text-gray-500" href={slug}>
                    Read More
                  </a>
                </div>
              </div>
            </div>
            <div class="py-8 px-6 text-center bg-gray-50 lg:flex-shrink-0 lg:flex lg:order-first lg:flex-col lg:justify-center lg:p-5">
              <img class="h-64 rounded-lg" src={image} alt=""></img>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeaturedBlogItem;
